var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembershipOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.89971C2.5 4.35956 2.83792 3.87712 3.34555 3.69253L7.31651 2.24854C7.75803 2.08799 8.24197 2.08799 8.68349 2.24854L12.6545 3.69253C13.1621 3.87712 13.5 4.35956 13.5 4.89972V5.90532C13.5 9.04593 11.7845 11.9357 9.0274 13.4396C8.387 13.7889 7.613 13.7889 6.9726 13.4396C4.21547 11.9357 2.5 9.04593 2.5 5.90532V4.89971Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembershipOverview);
export default __webpack_public_path__ + "static/media/membership-overview.88e4fc0300eb942e6bc72dacb07687dc.svg";
export { ForwardRef as ReactComponent };